export const projects = [
    {
        title: "IAM Consultant",
        subtitle: "SAP CDC consultant",
        description: "Registration as a Service, SAML assertion, rest API's, front end maintainance, etc",
        image: "", 
        link: "",
    },
    {
        title: "Titanic Spaceship Kaggle",
        subtitle: "Data Science",
        description: "Problem statement to find out which passengers are going to survive the Titanic Spaceship Crash",
        image: "",
        link: "https://github.com/harsh3698/Titanic-Spaceship-kaggle",
    },
    {
        title: "Ekart logistics",
        subtitle: "MERN Stack",
        description: "Created a basic full stack web site where one can buy items, add to cart, check cart ",
        image: "",
        link: "",
    },
    {
        title: "Civil Finloan",
        subtitle: "React Js",
        description: "Front end of a website that provides loans to MSME sectors",
        image: "",
        link: "",
    },
    
];

export const skills = ['HTML', 'CSS', 'JavaScript', 'mongoDB', 'ReactJs', 'Python', 'SAP CDC (IAM)', 'nodeJS'];

export const skillsSVG = ['']

export const certifications = ['Infosys Certified Front End Web Developer', 'Infosys Certified Mongo Developer','IBM Data Science Professional Certificate', 'Azure AI-900', 'Coursera Machine Learning', 'Coursera Deep Learning', 'Smart Attendance Based Decision Support System for Mid-day Meal Scheme (IEEE)'];
